import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 18l0 -15","key":"svg-0"}],["path",{"d":"M15 6l-3 -3l-3 3","key":"svg-1"}],["path",{"d":"M15 21l-3 -3l-3 3","key":"svg-2"}]]

const IconArrowUpTail = createReactComponent('outline', 'arrow-up-tail', 'ArrowUpTail', __iconNode);

export default IconArrowUpTail;